import React, { ReactElement } from "react";
import VideoEmbed, { VideoEmbedProps } from "../components/VideoEmbed";

const Watch = (): ReactElement => {
  const videos: VideoEmbedProps[] = [
    {
      title: "Hum",
      url: "https://www.youtube.com/embed/TqDHU6SHFbY?si=h8lueZPL1sHfC8yO",
    },
    {
      title: "Lucky",
      url: "https://www.youtube.com/embed/ghl4CQTC2tw?si=ZKcP-i3WXxzuk8Ar",
    },
    {
      title: "Cherish The Day - Sade ( slowed + reverb )",
      url: "https://www.youtube.com/embed/zCdecAHeHMs",
    },
    {
      title: "Ambient Patch 3",
      url: "https://www.youtube.com/embed/Oq9eY_fOT0A",
    },
    {
      title: "Ambient Patch 2",
      url: "https://www.youtube.com/embed/tQ-2BhJ6Kig",
    },
    {
      title: "Ambient Patch 1",
      url: "https://www.youtube.com/embed/XTBXym2E4SM",
    },
  ];

  return (
    <div className="page-container">
      <p className="button" style={{ marginBottom: "5px" }}>
        <a
          href="https://www.youtube.com/channel/UCfV-QwkNccZ0M368JSu8LPw"
          target="_blank"
          rel="noreferrer"
        >
          YouTube Channel
        </a>
      </p>
      <div className="media-list-flex">
        {videos.map((props: VideoEmbedProps) => (
          <VideoEmbed
            caption={props.caption}
            key={props.title}
            title={props.title}
            url={props.url}
          />
        ))}
      </div>
    </div>
  );
};

export default Watch;
